import PaymentManagementView from './PaymentManagementView';
export default PaymentManagementView;
